<template>
    <a-collapse accordion v-model="activeKey">
        <a-collapse-panel header="Gestión de Paz y Salvo" key="1">
            <g-master name="gesiton"
                      :endpoint="gestion.endpoint"
                      :tableSetup="gestion.tableSetup"
                      @action="masterGestionAction"
                      ref="gestionMaster"
                      :isSpResponse="true">
                <template slot="progresoSlot" slot-scope="{text, record}">
                    <a-progress :percent="parseInt(record.porcentaje)" status="active"/>
                </template>
                <template slot="masterModal" slot-scope="{record}">
                    <g-lookup label="Empleado"
                              :formItemConfig="gestionModal.fiOptions"
                              endpoint="empleados"
                              :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :selectedObj.sync="gestionModal.empleadoSeleccionado"
                              ref="gestEmpDropDown"
                              :params="paramsEmpleadoActivo">
                    </g-lookup>
                    <a-form-item label="Id Person"
                                 v-bind="gestionModal.fiOptions">
                        <a-input v-decorator="['id_person']" readOnly></a-input>
                    </a-form-item>
                    <a-form-item label="Cargo"
                                 v-bind="gestionModal.fiOptions">
                        <a-input id="cargo" v-decorator="['cargo']" readOnly></a-input>
                    </a-form-item>
                    <g-dropdown endpoint="hierarchy_lookup"
                                label="Proceso"
                                :formItemConfig="gestionModal.fiOptions"
                                :decorator="['id_h_type_req', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                                :params="gestionModal.requestData.proceso"></g-dropdown>
                    <a-form-item v-bind="gestionModal.fiOptions" label="Fecha Esperada">
                        <a-date-picker style="width: 100%"
                                       v-decorator="['expected_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                    <a-form-item v-bind="gestionModal.fiOptions" label="Observaciones">
                        <a-textarea
                                autoSize
                                v-decorator="['observation', { trigger: 'change', rules: [{ required: true, message: 'Valor requerido' }]}]">
                        </a-textarea>
                    </a-form-item>
                    <g-dropdown endpoint="hierarchy_lookup"
                                label="Razón Terminación"
                                :formItemConfig="gestionModal.fiOptions"
                                :decorator="['termination_reason', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                                :params="gestionModal.requestData.razonT"></g-dropdown>

                    <a-form-item v-bind="gestionModal.fiOptions" label="Fecha Terminación">
                        <a-date-picker style="width: 100%"
                                       v-decorator="['termination_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>

                </template>
            </g-master>
        </a-collapse-panel>
        <a-collapse-panel header="Detalle" key="2" :disabled="desActivarDetalles">
            <a-card hoverable>
                <a-card-meta :title="gestion.registroSeleccionado.nombre"
                             :description="gestion.registroSeleccionado.cargo">
                    <a-avatar
                            slot="avatar"
                            :src="profileSrc"
                    />
                </a-card-meta>
                <template class="ant-card-actions" slot="actions">
                    <a-progress style="width: 80%" :strokeColor="{
        '0%': '#108ee9',
        '100%': '#87d068',
      }" :percent="parseInt(gestion.registroSeleccionado.porcentaje)" status="active"/>
                </template>
            </a-card>
            <div class="row">&nbsp;</div>
            <g-master name="paz_y_salvo"
                      :endpoint="masterPazSalvo.endpoint"
                      :tableSetup="masterPazSalvo.tableSetup"
                      :parentData="detalleRequestData"
                      :actions="false">
                <span slot="estadoRenderer" slot-scope="{text}">
                            <a-badge :status="text==='FINALIZADO' ? 'success' : 'warning'"/> {{text || 'PENDIENTE'}}
                    </span>
            </g-master>
        </a-collapse-panel>
    </a-collapse>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import DateUtils from '@/util/DateUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import UserUtil from 'CustomModules/GlobalBPOCore/Util/UserUtil'

  export default {
    data () {
      return {
        activeKey: 1,
        gestion: {
          endpoint: 'gestion_humana/gestion_paz_y_salvo',
          tableSetup: {
            columns: [
              {
                title: 'Progreso.',
                dataIndex: 'calificacion_prc',
                sorter: true,
                scopedSlots: {customRender: 'progresoSlot', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}
              },
              {title: 'Persona', dataIndex: 'id_person', sorter: true},
              {title: 'Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre Persona', dataIndex: 'nombre', sorter: true},
              {title: 'Cargo', dataIndex: 'cargo', sorter: true},
              {title: 'Proceso', dataIndex: 'tipo_proceso', sorter: true},
              {title: 'Fecha Esperada', dataIndex: 'fecha_esperada', sorter: true},
              {title: 'Observación', dataIndex: 'observation', sorter: true},
              {title: 'Razon Terminación', dataIndex: 'causa_retiro', sorter: true},
              {title: 'Fecha Terminación', dataIndex: 'termination_date', sorter: true},
            ],
            actions: {
              title: 'Acciones',
              key: 'acciones',
              scopedSlots: {customRender: 'hooverableAction'},
              width: 90,
              fixed: 'right',
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {icon: 'edit', type: 'link', style: 'height: 20px; width: 20px;'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {icon: 'delete', type: 'link', style: 'height: 20px; width: 20px;'}
                },
                {
                  name: 'detalles',
                  text: 'Detalles',
                  permisos: [],
                  props: {icon: 'search', type: 'link', style: 'height: 20px; width: 20px;'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id_person_req'
            },
            customSlots: ['estadoRenderer', 'customAction', 'progresoSlot']
          },
          registroSeleccionado: {}
        },
        gestionModal: {
          empleadoSeleccionado: {},
          fiOptions: {
            'label-col': {span: 8},
            'wrapper-col': {span: 16},
            'has-feedback': true
          },
          requestData: {
            proceso: {h_lookup_type: 'PERSON_REQUEST'},//PROCESOS_PAZYSALVO
            razonT: {h_lookup_type: 'CAUSA_RETIRO'},
          }
        },
        profileSrc: require('./../../../assets/anon_profile.png'),
        defaultPicture: require('./../../../assets/anon_profile.png'),
        masterPazSalvo: {
          endpoint: 'gestion_humana/paz_y_salvo',
          tableSetup: {
            columns: [
              {title: 'Proceso', dataIndex: 'proceso_paz_salvo', sorter: true},
              {title: 'Paz y Salvo', dataIndex: 'valor_paz_salvo', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'esatdo_desc',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Observación', dataIndex: 'observation', sorter: true},
              {title: 'Aprobado Por', dataIndex: 'nombre_aprobador', sorter: true},
              {title: 'Usuario', dataIndex: 'modified_by', sorter: true},
              {title: 'Fecha', dataIndex: 'modified_on', sorter: true}
            ],
            actions: false,
            tableConfig: {
              rowKey: 'id_peacesafe',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40']
              }
            },
            customSlots: ['estadoRenderer', 'customAction', 'progresoSlot']
          }
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.$refs.gestionMaster.modal.form.getFieldDecorator('cargo')
      this.$refs.gestionMaster.modal.form.getFieldDecorator('id_person')
      this.$refs.gestionMaster.modal.form.getFieldDecorator('expected_date')
      this.$refs.gestionMaster.modal.form.getFieldDecorator('termination_date')
    },
    methods: {
      masterGestionAction (action) {
        console.log(action)
        switch (action.action) {
          case 'masterCreate':
            this.gestionModal.empleadoSeleccionado = {}
            break
          case 'masterEdit':
            this.$refs.gestEmpDropDown && this.$refs.gestEmpDropDown.handleSearch(action.record.id_emp)
            this.$nextTick(() => {
              this.$refs.gestionMaster.modal.form.setFieldsValue({
                termination_date: moment(action.record.termination_date),
                expected_date: moment(action.record.expected_date)
              })
            })
            break
          case 'detalles':
            this.gestion.registroSeleccionado = action.record
            this.activeKey = 2
            break
        }
      }
    },
    computed: {
      detalleRequestData () {
        return {
          id_person_req: this.gestion.registroSeleccionado.id_person_req || -1
        }
      },
      desActivarDetalles () {
        return JsUtils.isEmpty(this.gestion.registroSeleccionado)
      },
      paramsEmpleadoActivo () {
        return {estado_activo: true}
      }
    },
    watch: {
      'gestionModal.empleadoSeleccionado': function () {
        if (JsUtils.isEmpty(this.gestionModal.empleadoSeleccionado)) {
          this.$refs.gestionMaster.modal.form.setFieldsValue({
            cargo: '',
            id_person: ''
          })
        } else {
          console.log('cambiado el obj seleccionado', this.gestionModal.empleadoSeleccionado)
          this.$refs.gestionMaster.modal.form.setFieldsValue({
            cargo: this.gestionModal.empleadoSeleccionado.cargo,
            id_person: this.gestionModal.empleadoSeleccionado.id_person
          })
        }
      },
      'gestion.registroSeleccionado': function () {
        this.profileSrc = this.defaultPicture
        console.log('cargando foto de perfil')
        if (!JsUtils.isEmpty(this.gestion.registroSeleccionado)) {
          this.httpClient.getInstance().get('picture_service/render/profile/' + this.gestion.registroSeleccionado.id_person, {
            responseType: 'arraybuffer'
          })
            .then((response) => {
              let blob = new Blob([response.data], {type: response.headers['content-type']})
              this.profileSrc = window.URL.createObjectURL(blob)
            })
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/PazYSalvo/PazYSalvo.vue